/**
 * Controller for AppManager
 */
define('controllers/myservices/sel-pkg.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('selPkgCtrl', ['$q', '$scope', '$location', '$stateParams', '$filter', '$state', 'UserInfo', 'auiDialog', 'UserInfoPreload', 'myServicesPackage', 'OpenApp',
        'payService', 'gameService', 'huaweiIdService', 'OpenGW', 'ngDialog',
        function ($q, $scope, $location, $stateParams, $filter, $state, UserInfo, auiDialog, UserInfoPreload, myServicesPackage, OpenApp,
                  payService, gameService, huaweiIdService, OpenGW, ngDialog) {
            var Model = $scope.Model = {};
            Model.serviceItem = $stateParams.serviceItem;
            Model.product = $stateParams.product;
            if (!Model.serviceItem) {
                $state.go("home");
            }
            var getProdListSearchCache = {};
            Model.selected = {};
            Model.productTypes = mainCons.myserviceRollout.productTypes.filter(function (item) {
                return item.switch !== false;
            });
            Model.apkListShowTypes = mainCons.myserviceRollout.apkListShowTypes;
            Model.rpkListShowTypes = mainCons.myserviceRollout.rpkListShowTypes;
            Model.themeListShowTypes = mainCons.myserviceRollout.themeListShowTypes;
            // 回调地址
            Model.showCallbackUrl = mainCons.myserviceRollout.showCallbackUrl;
            // 包名
            Model.showPackageName = mainCons.myserviceRollout.showPackageName;
            // 证书指纹
            Model.showFingerPrint = mainCons.myserviceRollout.showFingerPrint;

            Model.isNotShowNewProductBut = mainCons.myserviceRollout.isNotShowNewProductBut;
            Model.modifyUri = systemParaConf.documentHref.modifyCallbackUrl;
            Model.defaultProductTypeFilterMap = {};
            mainCons.myserviceRollout.productTypes.forEach(
                function (t) {
                    Model.defaultProductTypeFilterMap[t.type] = t["name"];
                }
            );
            //是否支持服务器应用
            Model.supportServer = false;
            //运动健康
            Model.constant = {
                openStateFilter: mainCons.appConstant.openStateFilter
            };
            var nextUrlSrefMap = mainCons.myservicePackage.nextUrlSref;
            var packageListValuesMap = mainCons.myserviceRollout.packageListValues;
            var hasPackageListProductTypeMap = mainCons.myservicePackage.hasPackageListProductType;
            var hasOnlyProductTypeMap = mainCons.myservicePackage.hasOnlyProductType;
            Model.UserInfoPreload = UserInfoPreload;
            //方法区
            $scope.setProductType = setProductType;
            $scope.contains = contains;
            $scope.newProduct = newProduct;
            $scope.getProAbsList = getProAbsList;
            $scope.adaptEquip = adaptEquip;
            //packageList
            $scope.changSelectPackage = changSelectPackage;
            $scope.isDistributionService = isDistributionService;
            //下一步和取消
            $scope.nextStep = nextStep;
            $scope.previousStep = previousStep;
            $scope.submitService = submitService;

            $scope.changeProduct = changeProduct;

            function isDistributionService(item) {
                return AUI.BaseJSUtil.contains(mainCons.appConstant.growServices, item);
            }

            /**新建产品之后设置数据*/
            function setProduct(res) {
                Model.product.prodName = res.prodName;
                $scope.$parent.Model.productName = res.prodName;
                Model.selected.prodID = res.prodID;
                Model.product.prodType = Model.selected.prodType;
                Model.product.prodID = res.prodID;
                Model.product.srvSerialNo = res.srvSerialNo;//新建应用自动刚添加服务，把服务号放进product，方便传递
                if (Model.selected.webAppUrl) delete Model.selected.webAppUrl;
                //Push6支付8帐号32游戏服务52
                if (AUI.BaseJSUtil.contains([6, 8, 32, 52], Model.serviceItem)) {
                    //添加产品成功后显示秘钥
                    showSecret(res.prodID);
                } else {
                    auiDialog.success('新建产品成功');
                }
                getAppInfo(res.prodID);
                getPackageList();
                getProdListSearchCache = {};
                getProAbsList();
                Model.productSelect = angular.copy(Model.product);
            }

            //显示到appDetail页面
            function showSecret(appID) {
                // 获取app secret
                var gwParams = {
                    appId: appID,
                    attrs: ["secret"]
                }
                OpenGW.getAppInfo(gwParams).then(function (data) {
                    var secret = data.secret;
                    if (secret && gwParams.appId) {
                        ngDialog.open({
                            template: 'pages/myservices/pay/get-secret-Info.html',
                            className: '',
                            closeByEscape: false,
                            closeByDocument: false,
                            overlay: false,
                            controller: ['$scope', function ($scopeDlg) {
                                $scopeDlg.appId = gwParams.appId;
                                $scopeDlg.secret = secret;
                                //提交产品选择的语言
                                $scopeDlg.cancel = function () {
                                    ngDialog.close();
                                }
                            }]
                        });
                    }
                });
            }

            function newProduct() {
                if (!Model.selected.prodType) return;
                if (!UserInfoPreload.nationalCode) {
                    UserInfo.getAccountBaseInfo().then(function (resp) {
                        myServicesPackage.newProduct(Model, resp).then(function (res) {
                            if (res && res.prodID) {
                                setProduct(res);
                            }
                        });
                    })
                } else {
                    myServicesPackage.newProduct(Model, UserInfoPreload).then(function (res) {
                        if (res && res.prodID) {
                            setProduct(res);
                        }
                    });
                }

            }

            //下一步和取消
            function nextStep(type) {
                var defer = $q.defer();
                Model.notFinishedForm = angular.copy(mainCons.myservicePackage.notFinishedForm);
                if (Model.selected.prodID && (!Model.selected.package && (contains(Model.apkListShowTypes, Model.serviceItem + '-' + Model.selected.prodType) || (contains(Model.rpkListShowTypes, Model.serviceItem + '-' + Model.selected.prodType) && (Model.selected.prodType == '19-1' || Model.selected.prodType == '23')) || (contains(Model.themeListShowTypes, Model.serviceItem + '-' + Model.selected.prodType))))) {
                    Model.notFinishedForm['packageSelected'].showFlag = true;
                }
                if ($scope.packageForm.$invalid || Model.notFinishedForm['packageSelected'].showFlag || Model.notFinishedForm['themePKGSelected'].showFlag || Model.notFinishedForm['wallpaperPKGSelected'].showFlag) {
                    $scope.packageForm.$setDirty();
                    var callbackCount = 0;
                    for (var key in $scope.packageForm) {
                        //只遍历对象自身的属性，而不包含继承于原型链上的属性。
                        if (Object.prototype.hasOwnProperty.call($scope.packageForm, key) === true && key.indexOf('$') < 0) {
                            $scope.packageForm[key].$setDirty();
                            if ($scope.packageForm[key].$invalid) {
                                //只处理一个回调地址的问题
                                if (!Model.notFinishedForm[$scope.packageForm[key].$name]) {
                                    if (callbackCount > 0) {
                                        break;
                                    } else {
                                        callbackCount++;
                                        Model.notFinishedForm[$scope.packageForm[key].$name] = {
                                            title: '回调地址',
                                            errorText: '请输入正确的回调地址'
                                        };
                                    }
                                }
                                Model.notFinishedForm[$scope.packageForm[key].$name].showFlag = true;
                                // 自定义错误显示
                                if (angular.element("[ng-form]") && angular.element("[ng-form]").find("[name='" + $scope.packageForm[key].$name + "'],[self-tips]")) {
                                    var selfTips = angular.element("[ng-form]").find("[name='" + $scope.packageForm[key].$name + "']").attr("self-tips");
                                    if (angular.isFunction(Model[selfTips])) {
                                        var errorText = Model[selfTips]();
                                        if (errorText) Model.notFinishedForm[$scope.packageForm[key].$name].errorText = errorText;
                                    }
                                }
                            }
                        }
                    }
                    defer.reject();
                    auiDialog.singlePageNotFinished(angular.copy(Model.notFinishedForm), 'pages/myservices/common/app-market-service-error.html');
                    return defer.promise;
                }

                if (Model.product && Model.product.prodType) {
                    myServicesPackage.checkPackageNumber(Model.selected, Model.product, Model.packageList).then(function (res) {
                        if (!res) {
                            defer.resolve();
                            return defer.promise;
                        } else {

                            if (type == "submit") {
                                submitService().then(function () {
                                    defer.resolve();
                                }).catch(function () {
                                    defer.reject();
                                });
                            } else {
                                myServicesPackage.addCurrService(Model.selected.prodID, Model.product.prodType, Model.serviceItem, Model).then(function (res) {
                                    if (res) {
                                        Model.product.selected = angular.copy(Model.selected);
                                        $state.go($filter('auiMapWithDefault')(Model.serviceItem + '-' + (Model.product.prodType == "19" ? Model.product.prodType + '-' + Model.product.freeInstallType : Model.product.prodType), nextUrlSrefMap), {
                                            serviceItem: Model.serviceItem,
                                            product: Model.product
                                        });
                                    }
                                    defer.resolve();
                                }).catch(function () {
                                    defer.resolve();
                                });
                            }
                        }
                    }).catch(function () {
                        defer.resolve();
                    })

                } else {
                    defer.resolve();
                    auiDialog.warn("请选择产品类型")
                }
                return defer.promise;
            }


            /**
             * 提交开发服务
             */
            function submitService() {
                var defer = $q.defer();
                var submitFun = function () {
                };
                if (Model.serviceItem == 8) submitFun = payService.submit;
                else if (Model.serviceItem == 32) submitFun = huaweiIdService.submit;
                else if (Model.serviceItem == 52) submitFun = gameService.submit;
                submitFun(Model, UserInfoPreload).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function previousStep() {
                $state.go('myServiceList', {serviceItem: Model.serviceItem}, {reload: true});
            }

            function changeProduct(selected) {
                Model.product = selected;
                for (var i in Model.selected) {
                    i != 'prodType' && (Model.selected[i] = "");
                }
                $scope.packageForm && $scope.packageForm.$setPristine(true);
                if (Model.selected && selected) {
                    Model.selected.prodID = selected.prodID;
                }
                $scope.$parent.Model.productName = selected.prodName;
                getPackageList();
                if (Model.selected.webAppUrl) delete Model.selected.webAppUrl;
                getAppInfo(selected.prodID);
            }


            function changSelectPackage(package) {
                if (package.pkgVersion) Model.selected.pkgVersion = package.pkgVersion;
                Model.selected.package = package;
                if (package.pkgVersion) Model.product.pkgVersion = package.pkgVersion;
                if (package.rpkID) Model.selected.rpkID = package.rpkID;
                if (package.rpkID) Model.product.rpkID = package.rpkID;
            }


            function setProductType(type) {
                if (!Model.product || !Model.product.isUpdate) {
                    for (var i in Model.selected) {
                        i != 'prodType' && (Model.selected[i] = "");
                    }
                    Model.selected.prodType = type;
                    Model.productSelect = '';
                    Model.product = {};
                    Model.product.prodType = type;
                    Model.selected.callbackUrlList = [''];
                    getProAbsList();
                    getPackageList(true);
                }
                $scope.packageForm && $scope.packageForm.$setPristine(true);
                if (Model.serviceItem == 32) {
                    huaweiIdService.resetAccessMode(Model);
                }

            }

            //包含
            function contains(arr, obj) {
                return AUI.BaseJSUtil.contains(arr, obj);
            }

            //更新package列表
            function getPackageList(flag) {
                var prodTypeTemp;
                Model.packageList = [];
                prodTypeTemp = (Model.product.prodType + '').indexOf('-') > -1 ? Model.product.prodType.split('-')[0] : Model.product.prodType;
                Model[$filter('auiMapWithDefault')(prodTypeTemp, packageListValuesMap)] = [];
                if (contains(hasPackageListProductTypeMap, Model.selected.prodType + '-' + Model.serviceItem) && !flag) {
                    myServicesPackage.getPackageList(Model.product).then(function (res) {
                        if (res && res.resultCode == 0) {
                            if (res[$filter('auiMapWithDefault')(prodTypeTemp, packageListValuesMap)]) {
                                res[$filter('auiMapWithDefault')(prodTypeTemp, packageListValuesMap)].forEach(function (package) {
                                    if (package.activeState == 0) {
                                        Model[$filter('auiMapWithDefault')(prodTypeTemp, packageListValuesMap)].push(package);
                                    }
                                    Model.packageList.push(package);
                                    if (((package.pkgVersion && package.pkgVersion == Model.selected.pkgVersion) || (package.rpkID && package.rpkID == Model.selected.rpkID)) && package.activeState == 0) {
                                        Model.selected.package = package;
                                    }
                                });
                            }
                        }
                    });
                } else {
                    Model[$filter('auiMapWithDefault')(prodTypeTemp, packageListValuesMap)] = [];
                }
            }

            function getAppInfo(appID) {
                if (Model.product && Model.product.appInfo) delete Model.product.appInfo;
                // 查询appInfo
                OpenApp.getAppDetail({
                    request: {
                        appID: appID
                    }
                }).then(function (data) {
                    if (data && data.resultCode === 0) {
                        Model.product.appInfo = data.appInfo;
                        if (Model.product.appInfo.webAppUrl && !Model.selected.webAppUrl) {
                            Model.selected.webAppUrl = Model.product.appInfo.webAppUrl;
                        }
                        //设置回调地址
                        if (Model.product.appInfo.appAttrs && Model.serviceItem != 8) {
                            if (Model.product.appInfo.appAttrs.oauthRedirectUri) {
                                Model.selected.callbackUrl = Model.product.appInfo.appAttrs.oauthRedirectUri;
                                Model.selected.callbackUrlList = [Model.product.appInfo.appAttrs.oauthRedirectUri];
                            } else {
                                Model.selected.callbackUrlList = [''];
                            }
                            //设置回调地址列表
                            if (Model.product.appInfo.appAttrs.oauthRedirectUriExtra) {
                                Model.selected.callbackUrlList = Model.selected.callbackUrlList.concat(angular.fromJson(Model.product.appInfo.appAttrs.oauthRedirectUriExtra));
                            }

                        }

                        //运动健康 是否支持服务器应用
                        if (Model.product.appInfo.webAppType && Model.product.appInfo.webAppType == '1,2') {
                            Model.supportServer = true;
                        }

                        if (Model.product.appInfo.bundleId) {
                            Model.selected.bundleId = Model.product.appInfo.bundleId;
                            Model.selected.bundleIdDisable = Model.selected.bundleId && Model.selected.bundleId.length > 0
                        } else {
                            delete Model.selected.bundleId;
                            delete Model.selected.testBundleId;
                            Model.selected.bundleIdDisable = false;
                            Model.selected.testBundleIdDisable = false;
                        }
                        if (Model.product.appInfo.testBundleId) {
                            Model.selected.testBundleId = Model.product.appInfo.testBundleId;
                            Model.selected.testBundleIdDisable = Model.selected.testBundleId && Model.selected.testBundleId.length > 0
                        }
                        if (data.appInfo && data.appInfo.languages[0] && data.appInfo.languages[0].appIcon) {
                            //如果当前存在APPICon 则展示
                            Model.appIcon = data.appInfo.languages[0].appIcon;
                        }
                    }
                });
            }


            function getProAbsList(text) {
                var param = {request: {}};
                if (!Model.product || !Model.selected.prodType) return;
                param.request = angular.copy(mainCons.myserviceRollout.getProAbsListParam[Model.serviceItem + '-' + Model.selected.prodType] ? mainCons.myserviceRollout.getProAbsListParam[Model.serviceItem + '-' + Model.selected.prodType] : {});
                param.request.noServiceItem = ~~Model.serviceItem;
                if (text) {
                    param.request.searchTxt = text;
                }
                if (Model.selected.prodType && Model.selected.prodType == "19-1") {
                    param.request.freeInstallType = 1;
                } else if (Model.selected.prodType && Model.selected.prodType == "19-2") {
                    param.request.freeInstallType = 2;
                }
                param.request.maxReqCount = 100;
                param.request.prodType = angular.copy([~~(Model.selected.prodType.toString().indexOf('-') > 0 ? Model.selected.prodType.toString().split('-')[0] : Model.selected.prodType)]);
                if (angular.toJson(getProdListSearchCache) != angular.toJson(param)) {
                    Model.productList = [];
                    getProdListSearchCache = angular.copy(param);
                    OpenApp.getProAbsList(param).then(function (res) {
                        if (res.proAbsList && res.proAbsList.length > 0) {
                            Model.isHaveProdcut = true;
                            res.proAbsList.forEach(function (proAb) {
                                if (proAb.prodState != 3 && proAb.prodState != 4 && proAb.prodState != 6) {
                                    Model.productList.push(proAb);
                                }
                            });
                        } else {
                            Model.isHaveProdcut = false;
                        }
                    });
                }
            }

            //控制选中未选中
            function adaptEquip() {
                if (Model.product.isUpdate) {
                    return;
                }
                Model.supportServer = !Model.supportServer;
            }

            !function () {
                UserInfo.getWhiteListCache();
                if (Model.product) {
                    Model.productSelect = angular.copy(Model.product);
                    if (Model.product.isUpdate) { //上架更新场景
                        Model.selected.prodType = Model.product.freeInstallType ? Model.product.prodType + "-" + Model.product.freeInstallType : Model.product.prodType;
                        Model.selected.prodID = Model.product.prodID;
                        if (Model.product.serviceSingle && Model.product.serviceSingle.pkgVersion) Model.selected.pkgVersion = Model.product.serviceSingle.pkgVersion;
                        if (Model.product.serviceSingle && Model.product.serviceSingle.rpkID) Model.selected.rpkID = Model.product.serviceSingle.rpkID;
                    }
                    if (Model.product.selected) {//从第二步应用详情的上一步过来
                        Model.selected = angular.copy(Model.product.selected);
                    }
                    getPackageList();
                    getAppInfo(Model.product.prodID);
                } else {
                    //todo
                    if (hasOnlyProductTypeMap[Model.serviceItem]) {
                        setProductType(hasOnlyProductTypeMap[Model.serviceItem]);
                    }
                }


            }()
        }]);
});

